import React from 'react';
import {
  Box, Button, Typography,
} from '@mui/material';
import { Trans, useTranslation } from '@gamiphy/react-i18n';
import { observer } from 'mobx-react';
import { ApplicableDiscountDiscount, ProductDto } from '@coretava/api/ecommerce-service';
import { CampaignUserStore } from '@gamiphy/loyalty-station-desktop/store/campaignUsers';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { getDiffInDays } from '@gamiphy/utils/date';
import { DisplayString, getDisplayStringValue } from '@coretava/i18n';

const FreeSkuDiscount: React.FC<{ discount: ApplicableDiscountDiscount }> = ({ discount }) => {
  const [product, setProduct] = React.useState<ProductDto>();
  const { i18n } = useTranslation();

  React.useEffect(() => {
    if (discount.skuDetails?.productId) {
      void CampaignUserStore.productApi.productsControllerGetByExternalId(AppStore.app.id, discount.skuDetails?.productId)
        .then((res) => setProduct(res.data.product));
    }
  });

  return (
    <Box display="flex" flexDirection="column" gap={1.5} textAlign="center">
      {product?.images[0] && (
        <Box component="img" src={product?.images[0]} mb={2} sx={{ maxWidth: '100%', maxHeight: '13rem', objectFit: 'contain' }} />
      )}
      <Typography fontSize="2.4rem" fontWeight={600}>
        <Trans
          i18nKey="cashbackPopup.discount.freeSku.title"
          defaults="🎉 Claim Your Free Gift – Limited Time Only! 🛍️✨"
        />
      </Typography>
      <Typography fontSize="1.6rem" color="#4F4F4F">
        <Trans
          i18nKey="cashbackPopup.discount.freeSku.subtitle"
          defaults="🎁 Get {{skuName}} as a reward – Yours with your next purchase!"
          values={{
            skuName: product?.name && getDisplayStringValue(i18n, product?.name as DisplayString),
          }}
        />
      </Typography>
      <Button
        variant="contained"
        fullWidth
        onClick={() => window.open(product?.url ?? undefined, '_blank')}
      >
        <Trans
          i18nKey="coreloyalty.cashback.shopNow"
          defaults="Shop now"
        />
      </Button>
      {discount.expiresAt && (
      <Typography fontSize="1.4rem" fontWeight={500} color="#344054">
        <Trans
          i18nKey="discounts.bogo.validFor"
          defaults="Valid for {{validity}} days"
          values={{
            validity: getDiffInDays(new Date(discount.expiresAt), new Date()),
          }}
        />
      </Typography>
      )}
    </Box>
  );
};

export default observer(FreeSkuDiscount);
